import request from '@/utils/request';
export function auditList(data) {
  return request.post('admin/audit-flow/list', data);
}
export function addAudit(data) {
  return request.post('admin/audit-flow/store', data);
}
export function editAudit(data) {
  return request.post('admin/audit-flow/edit', data);
}
export function auditDetail(data) {
  return request.post('admin/audit-flow/detail', data);
}
export function delAudit(data) {
  return request.post('admin/audit-flow/delete', data);
}
export function auditStatus(data) {
  return request.post('admin/audit-flow/status', data);
}
export const markList = [
// { name: '产品上线', value: 'product_launch' },
// { name: '产品修改', value: 'product_change' },
// { name: '应用上线', value: 'version_online' },
{
  name: '申请理赔',
  value: 'claims'
}, {
  name: '问卷',
  value: 'questionnaire'
}];
export const typeList = [{
  name: '内容审核',
  value: 1
}, {
  name: '产品相关审核',
  value: 2
}, {
  name: '应用上线审核',
  value: 3
}, {
  name: '财务审核',
  value: 4
}, {
  name: '理赔审核',
  value: 5
}];
export function flowNodeList(data) {
  return request.post('admin/flow-node/list', data);
}
export function addFlowNode(data) {
  return request.post('admin/flow-node-config/store', data);
}
export function editFlowNode(data) {
  return request.post('admin/flow-node-config/edit', data);
}
export function flowNodeDetail(data) {
  return request.post('admin/flow-node-config/detail', data);
}
//配置回显数据(废弃)
export function flowNodeEcho(data) {
  return request.post('admin/flow-node-whitelist/echo/data', data);
}
// export function delFlowNode(data) {
//   return request.post('admin/flow-node/delete', data);
// }
// export function flowNodeMove(data) {
//   return request.post('admin/flow-node/move', data);
// }
//白名单人员下拉列表
export function whiteList(data) {
  return request.post('admin/flow-node-whitelist/list', data);
}
export function addWhite(data) {
  return request.post('admin/flow-node-whitelist/store', data);
}
//审核流节点校验
export function flowNodeVerify(data) {
  return request.post('admin/flow-node-config/verify', data);
}

// 2023/9
// 国家接口数据
export function countriesDATA(data) {
  return request.post('/admin/flow-node-config/countries', data);
}

// 省市接口数据
export function planArea(data) {
  return request.post('admin/v2/insurance-plan/area', data);
}
// 银行
export function bankData(data) {
  return request.post('/admin/flow-node-config/bank', data);
}
// 物流
export function logisticsData(data) {
  return request.post('/admin/flow-node-config/logistics', data);
}

// 自定义新增
export function cascadestore(data) {
  return request.post('/admin/flow-node-config/cascade-store', data);
}

// 自定义 编辑
export function cascadeedit(data) {
  return request.post('/admin/flow-node-config/cascade-edit', data);
}

// 自定义删除
export function cascadedelete(data) {
  return request.post('/admin/flow-node-config/cascade-delete', data);
}

// 自定义列表
export function cascadelist(data) {
  return request.post('/admin/flow-node-config/cascade-list', data);
}

//签名上传
export function cascadesign(data) {
  return request.post('/admin/flow-node-config/sign', data);
}
export const uploadFile = process.env.VUE_APP_BASE_API + 'upload/file';